<mat-form-field class="light-form-field">
  <mat-label>{{
    label || ("shift" | i18n) || "Schicht" | titlecase
  }}</mat-label>
  <mat-select
    [ngModel]="selectedShifts"
    (ngModelChange)="onSelectionChange($event)"
    [disabled]="disabled"
    [required]="required"
    multiple
    [attr.data-cy]="'shift-select'">
    <!-- ALL option as a regular selectable option -->
    <mat-option
      [value]="'ALL'"
      [attr.data-cy]="'shift-option-all'">
      {{ ("all" | i18n) || "Alle" }}
    </mat-option>
    <mat-divider></mat-divider>

    <!-- Individual shift options -->
    <mat-option
      *ngFor="let shift of shiftEnum | enumToArray"
      [value]="shiftEnum[shift]"
      [attr.data-cy]="'shift-option-' + shiftEnum[shift]">
      {{ ("shifts." + shiftEnum[shift] | i18n) || shiftEnum[shift] }}
    </mat-option>
  </mat-select>
</mat-form-field>
